import * as React from "react";

export interface ListNavigation {
  onNavigate: (dir: -1 | 1) => void;
  canPrev: boolean;
  canNext: boolean;
}

/** Step the selection through the rows currently on screen. */
export function useListNavigation<T extends { id: bigint | number | string }>(
  items: T[],
  selected: T | null,
  onSelect: (item: T) => void,
): ListNavigation {
  const index = selected ? items.findIndex((i) => String(i.id) === String(selected.id)) : -1;

  const onNavigate = React.useCallback(
    (dir: -1 | 1) => {
      const next = index < 0 ? undefined : items[index + dir];
      if (next) onSelect(next);
    },
    [index, items, onSelect],
  );

  return {
    onNavigate,
    canPrev: index > 0,
    canNext: index >= 0 && index < items.length - 1,
  };
}
